@if (chartData) {
  <div id="tab-tabell-detaljer" class="my-4 px-md-4 px-2">
    <div class="row justify-content-center">
      <div class="col"></div>
      <div class="col-lg-7">
        <h4 class="table-title" [innerHTML]="chartData.chartTitle"></h4>
        <h6 class="table-subtitle mb-lg-4 mb-2" [innerHTML]="chartData.chartSubTitle"></h6>
      </div>
      <div class="col">
        <button type="button" class="btn btn-outline-primary btn-sm p-2 mb-3 float-end" (click)="getExcelFile()" >
          <i class="float-end fas fa-lg fa-file-excel"></i>
          &ensp;{{ 'xml-report.details.create-excel' | translate }}
        </button>
      </div>
    </div>
    <div class="table-div">
      <angular2-smart-table
        [settings]="settings | async"
        [source]="source">
      </angular2-smart-table>
    </div>
  </div>
}